import http from "../../helpers/http";

import {
  FETCH_CORPORATE_PARTNERS_CONTENT_SUCCESS,
  FETCH_CORPORATE_PARTNERS_CONTENT_FAILED
} from "../actions/actionTypes";

export const fetchData = () => (dispatch) => {
  http
    .get("corporate-partners")
    .then(({ data }) => {
      dispatch({
        type: FETCH_CORPORATE_PARTNERS_CONTENT_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_CORPORATE_PARTNERS_CONTENT_FAILED,
        payload: error
      });
    });
};
